import { render, staticRenderFns } from "./HomePageFeatureBobSaget.vue?vue&type=template&id=96d611ea&scoped=true&"
import script from "./HomePageFeatureBobSaget.vue?vue&type=script&lang=js&"
export * from "./HomePageFeatureBobSaget.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFeatureBobSaget.vue?vue&type=style&index=0&id=96d611ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d611ea",
  null
  
)

export default component.exports